import React from "react";

export const Button = ({ children, className = "", variant = "primary", size = "md", ...props }) => {
  // Bootstrap button base classes
  let btnClass = `btn btn-${variant}`;

  // Add size class
  if (size === "lg") {
    btnClass += " btn-lg";
  } else if (size === "sm") {
    btnClass += " btn-sm";
  }

  return (
    <button className={`${btnClass} ${className}`} {...props}>
      {children}
    </button>
  );
};
